var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDecor2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 189,
    height: 297,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M78.497 65.443l40.123 48.738 18.994-70.885-59.117 22.147z",
    fill: "#D0D0D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.933 137.824l-9.825 3.997-3.996-9.825-6.288 2.558 3.997 9.824-9.825 3.996 2.558 6.288 9.824-3.996 3.996 9.824 6.288-2.557-3.996-9.825 9.824-3.996-2.557-6.288z",
    fill: "#2FC7D5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M111.687 222.657l38.862-94.24 62.294 81.057-101.156 13.183zm40.673-82.701l-31.09 75.392 80.911-10.74-49.821-64.652z",
    fill: "#FDC71B"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTg5IiBoZWlnaHQ9IjI5NyIgdmlld0JveD0iMCAwIDE4OSAyOTciIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik03OC40OTY4IDY1LjQ0MjhMMTE4LjYyIDExNC4xODFMMTM3LjYxNCA0My4yOTU2TDc4LjQ5NjggNjUuNDQyOFoiIGZpbGw9IiNEMEQwRDAiLz4KPHBhdGggZD0iTTY3LjkzMjYgMTM3LjgyNEw1OC4xMDgyIDE0MS44MjFMNTQuMTEyIDEzMS45OTZMNDcuODI0NCAxMzQuNTU0TDUxLjgyMDYgMTQ0LjM3OEw0MS45OTYyIDE0OC4zNzRMNDQuNTUzOCAxNTQuNjYyTDU0LjM3ODIgMTUwLjY2Nkw1OC4zNzQ0IDE2MC40OUw2NC42NjIgMTU3LjkzM0w2MC42NjU4IDE0OC4xMDhMNzAuNDkwMiAxNDQuMTEyTDY3LjkzMjYgMTM3LjgyNFoiIGZpbGw9IiMyRkM3RDUiLz4KPHBhdGggZD0iTTExMS42ODcgMjIyLjY1N0wxNTAuNTQ5IDEyOC40MTdMMjEyLjg0MyAyMDkuNDc0TDExMS42ODcgMjIyLjY1N1pNMTUyLjM2IDEzOS45NTZMMTIxLjI3IDIxNS4zNDhMMjAyLjE4MSAyMDQuNjA4TDE1Mi4zNiAxMzkuOTU2WiIgZmlsbD0iI0ZEQzcxQiIvPgo8L3N2Zz4K";
export { SvgDecor2 as ReactComponent };